import React, { Component } from 'react';
import ProgressiveImage from 'react-progressive-image';
import { isIE } from '../index';

import imageLoader from '../../assets/img/loader.svg';

class ResponsiveImage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            imageFallback: ''
        }

        this.imageOnError = this.imageOnError.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.filename !== nextProps.filename
            || this.props.imagesPath !== nextProps.imagesPath) {
                this.setState({
                    imageFallback: ''
                });
        }
    }

    imageOnError() {
        const { imagesPath, imageSizeParams, filename } = this.props;

        // disable functionality for IE11 because of buggy onError event
        if (isIE(true) === 11) {
            return false;
        }

        this.setState({
            imageFallback: imagesPath + encodeURIComponent(filename) + imageSizeParams.walk
        });
    }

    render() {
        const { imagesPath, imageSizeParams, filename, lazyLoad } = this.props;
        const { imageFallback } = this.state;
        const fullFilename = imagesPath + encodeURIComponent(filename);
        const getSrc = () => {
            if (imageSizeParams) {
                if (window.innerWidth < 400) {
                    return fullFilename + imageSizeParams.original;

                } else if (window.innerWidth < 640) {
                    return fullFilename + imageSizeParams.walk;

                } else if (window.innerWidth < 720) {
                    return fullFilename + imageSizeParams.wide;

                }
                return fullFilename + imageSizeParams.fullhd;
            }
            return fullFilename;
        }

        const srcSet = imageSizeParams
            ?  fullFilename + imageSizeParams.original + ' 400w,'
                + fullFilename + imageSizeParams.walk + ' 640w,'
                + fullFilename + imageSizeParams.wide + ' 720w,'
                + fullFilename + imageSizeParams.fullhd + ' 1920w'
            : null;

        const imageLoaderStyle = {
            position: 'relative',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            height: 'initial',
            width: 'initial'
        }

        return (
            <ProgressiveImage
                src={getSrc()}
                srcSet={srcSet}
                sizes='(max-width: 1600px) 100vw, 80%'
                placeholder={lazyLoad ? imageLoader : ''}
            >
            {(src, loading) => {
                if (loading) {
                    return (
                        <img
                            style={imageLoaderStyle}
                            src={src}
                            alt='loading'
                        />
                    )
                } else {
                    return (
                        <img
                            src={imageFallback || src}
                            ref={img => this.img = img}
                            srcSet={imageFallback ? '' : srcSet}
                            onError={this.imageOnError}
                            alt='image'
                        />
                    )
                }
            }}
            </ProgressiveImage>
        );
    }
}

export default ResponsiveImage;
